module.exports = __webpack_public_path__ + "img/cachorro.d136a494.gif";